import * as React from 'react';

import { IDocument, ICoverImage } from '../../infrastructure/interfaces';
import Radio from '../Radio';

export interface ICoverImagesEditorFormProps {
  document: IDocument;
  coverImages: ICoverImage[];
  onCoverImageChange(image: any): void;
  className: string;
}

export default class CoverImagesEditorForm extends React.Component<ICoverImagesEditorFormProps> {

  render() {
    return (
      <div className={this.props.className}>
        {this.props.coverImages.map((image, key) => (
          <div key={image.id} className="rowStepTwo">
            <Radio
              checked={(this.props.document.coverImage && this.props.document.coverImage.id === image.id)!}
              onChange={() => this.props.onCoverImageChange(image)}
            >
              <div className="image-box">
                <img alt={image.title} src={image.web.fullCover} />
                <span>{image.title}</span>
              </div>
            </Radio>
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentEditor/CoverImageEditorForm.tsx